import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { propOr } from 'ramda';
import { Query } from 'react-apollo';
import Avatar from '@material-ui/core/Avatar';
import { Link } from 'react-router-dom';
import Panel from '../Panel';
import { Settings as SettingsIcon } from '../../icons';
import Tabs from './Tabs';
import { stylesToPropType } from '../../utils';
import applicationPropType from './applicationPropType';
import { GET_APPLICATION_OWNER } from './queries';

const styles = () => ({
  title: {
    display: 'block',
  },
  panelContent: {
    minHeight: 'calc(80vh - 5em)',
    '& *': {
      fontWeight: '500',
    },
    '& [class^="Tree-label"]': {
      '&:hover': {
        color: 'rgb(48,183,255)',
      },
    },
    '& [class^="MuiFormControlLabel"]': {
      marginLeft: '12px',
    },
    '& [class^="MuiFormControl"]': {
      marginLeft: '12px',
    },
    '& [class^="MuiInput"]': {
      marginLeft: '12px',
    },
    '& [class^="TextField"]': {
      marginLeft: '12px',
    },
  },
  keys: {
    '& > *': {
      padding: '0.5em 0',
    },
  },
  titleLink: {
    color: '#1682bc',
  },
});

class UnstyledApplicationsSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      classes,
      application,
      refreshApp,
      ...rest
    } = this.props;

    return (
      <Query
        query={GET_APPLICATION_OWNER}
        notifyOnNetworkStatusChange
        variables={{ applicationID: application.applicationID }}
      >
        {({ data, loading, error }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;
          const {
            _id: id,
          } = data.applicationOwner;
          const ownerID = propOr('', 'ownerID', data.applicationOwner);
          const createdBy = propOr('', 'createdBy', data.applicationOwner);

          return (
            <Panel
              id="ApplicationsSettings"
              title={(
                <Link
                  className={classes.titleLink}
                  to={`${rest.match.url}`}
                >
                  {application.domain}
                  {application.childAppName.length > 0
                    && ' - '}
                  {application.childAppName}
                </Link>
              )}
              classes={{ title: classes.title }}
              avatar={<Avatar><SettingsIcon /></Avatar>}
            >
              <div className={classes.panelContent}>
                <Tabs
                  application={application}
                  ownerId={ownerID}
                  createdBy={createdBy}
                  appId={id}
                  refreshApp={refreshApp}
                  {...rest}
                />
              </div>
            </Panel>
          );
        }}
      </Query>
    );
  }
}

UnstyledApplicationsSettings.propTypes = {
  application: applicationPropType.isRequired,
  refreshApp: PropTypes.func.isRequired,
  classes: stylesToPropType(styles()).isRequired,
};

const AppSettings = withStyles(styles)(UnstyledApplicationsSettings);

export default AppSettings;
